import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import axios from 'axios';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import MovieDetailsPage from './pages/MovieDetailsPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import BookingsPage from './pages/BookingsPage';
import AdminPanelPage from './pages/AdminPanelPage';
import ContactPage from './pages/ContactPage';
import BookingPage from './pages/BookingPage';
import AllMoviesPage from './pages/AllMoviesPage'; // 1. Import the new page


function App() {
  const [city, setCity] = useState('Amritsar');
  const [category] = useState('All'); // Removed setCategory as FilterBar is removed
  const [allCities, setAllCities] = useState([]);
  const [categories, setCategories] = useState([]); // State for all categories
  const fetchAllCategories = async () => {
      try {
          const { data } = await axios.get('/api/categories');
          setCategories(data.map(c => c.name));
      } catch (error) {
          console.error("Could not fetch categories", error);
      }
  };
  useEffect(() => {
    
    const fetchAllCities = async () => {
        try {
            const { data } = await axios.get('/api/cities');
            const cityNames = data.map(c => c.name);
            setAllCities(cityNames);
            if (cityNames.length > 0 && !cityNames.includes(city)) {
              setCity(cityNames[0]);
            }
        } catch (error) {
            console.error("Could not fetch cities", error);
        }
    };
    fetchAllCities();
    fetchAllCategories();
  }, [city]);

  return (
    <Router>
      {/* 2. Add flexbox wrapper to make footer sticky */}
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header city={city} setCity={setCity} allCities={allCities} />
        {/* FilterBar removed - Home and Category dropdown hidden */}
        
        {/* 3. Make main content area expand */}
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<HomePage city={city} category={category} />} />
            <Route path="/movie/:id" element={<MovieDetailsPage />} />
            <Route path="/booking/:movieId" element={<BookingPage />} />
            <Route path="/contact" element={<Container className="my-4"><ContactPage /></Container>} />
            <Route path="/login" element={<Container className="my-4"><LoginPage /></Container>} />
            <Route path="/register" element={<Container className="my-4"><RegisterPage /></Container>} />
            <Route path="/my-bookings" element={<Container className="my-4"><BookingsPage /></Container>} />
            <Route path="/movies" element={<AllMoviesPage />} /> {/* 2. Add the route */}
            <Route path="/admin" element={<AdminPanelPage categories={categories} fetchCategories={fetchAllCategories} />} />
          </Routes>
        </main>

        <Footer /> {/* 4. Add the Footer component at the end */}
      </div>
    </Router>
  );
}

export default App;